import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import {
  CiderIngredientType,
  OtherAlcoholType,
  VermouthType,
} from 'src/app/products/interfaces/models';
import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

import { OtherAlcoholProperties } from '@app/api/marketplace/models';
import { FruitWineIngredientType } from '@products/interfaces/fruit-wine-ingredient-type';

@Component({
  selector: 'app-other-alcohol-properties-subform',
  templateUrl: './other-alcohol-properties-subform.component.html',
  styleUrls: ['./other-alcohol-properties-subform.component.scss'],
})
export class OtherAlcoholPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.OTHER_ALCOHOL_PROPERTIES';

  otherAlcoholType = OtherAlcoholType;
  ciderIngredientType = CiderIngredientType;
  fruitWineIngredientType = FruitWineIngredientType;
  vermouthType = VermouthType;

  static buildForm(fb: FormBuilder, data?: OtherAlcoholProperties) {
    return fb.group({
      otherAlcoholType: [data?.otherAlcoholType, Validators.required],
      ...(data?.otherAlcoholType == OtherAlcoholType.Cider && {
        ciderIngredientType: [data?.ciderIngredientType, Validators.required],
      }),
      ...(data?.otherAlcoholType == OtherAlcoholType.FruitWine && {
        fruitWineIngredientType: [
          data?.fruitWineIngredientType,
          Validators.required,
        ],
      }),
      ...(data?.otherAlcoholType == OtherAlcoholType.Vermouth && {
        vermouthType: [data?.vermouthType, Validators.required],
      }),
    });
  }

  onTypeSelected(selected: OtherAlcoholType) {
    if (selected === OtherAlcoholType.Vermouth) {
      this.group.addControl(
        'vermouthType',
        this.fb.control(null, Validators.required)
      );
    } else {
      this.rmCtrl('vermouthType');
    }

    if (selected === OtherAlcoholType.Cider) {
      this.group.addControl(
        'ciderIngredientType',
        this.fb.control(null, Validators.required)
      );
    } else {
      this.rmCtrl('ciderIngredientType');
    }

    if (selected === OtherAlcoholType.FruitWine) {
      this.group.addControl(
        'fruitWineIngredientType',
        this.fb.control(null, Validators.required)
      );
    } else {
      this.rmCtrl('fruitWineIngredientType');
    }
  }
}
